import { addOrderTicketForShowtime } from './add-order-ticket-for-showtime';
/**
 * Attempts to add a ticket to the order based on the number of remaining tickets available.
 * @returns `true` if the ticket was added or `false` if the ticket could not be added.
 */
export const attemptToAddOrderTicketForShowtime = (showtimeId, ticket, quantity) => {
    try {
        addOrderTicketForShowtime(showtimeId, ticket, quantity);
        return true;
    }
    catch (_a) {
        return false;
    }
};
